import {
  AddressTypeEnum,
  AdministrationPayerTypeEnum,
} from "@/shared/ModelEnums";
import PaymentSourceModel, {
  AdministrationPaymentSourceModel,
} from "./PaymentSourceModel";

export default class AdministrationPayerViewModel {
  administrationPayerTypeCd: AdministrationPayerTypeEnum =
    AdministrationPayerTypeEnum.APT_SO;
  paymentProviderAccountNum: string = "";
  paymentProviderReference: string = "";
  committeeMemberAddresses: CommitteeMemberAddressModel[] = [
    new CommitteeMemberAddressModel(),
  ];
  commencementDt?: Date;
  yearOfLastTaxReceipt: Number = 0;
  lastChargeDT?: Date;
  nextChargeDT?: Date;

  currentPaymentSource?: AdministrationPaymentSourceModel;

  concurrencyRV?: string;
}

export class CommitteeMemberAddressModel {
  addressTypeCd = AddressTypeEnum.AT_Ph;
  streetLine1 = "";
  streetLine2?: string;
  suburbOrCity = "";
  australianStateCd = "";
  postcode = "";
}
